import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Features } from "./Features";
import { Benefits } from "./Benefits";
import "./LandingPage.css";
import { PaletteItem } from "../palette/PaletteItem";
import { BlockTypes } from "../../models/block-types";

export const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-container">
      {/* Background Graph Grid Layer */}
      <div className="blueprint-grid" />

      {/* Navigation Header */}
      <nav className="landing-nav">
        <div className="logo-container">
          <img
            src="/logo100.png"
            alt="System Design Playground Logo"
            className="logo-img"
          />
          <Typography variant="h6" className="logo-text">
            System Design Playground
          </Typography>
        </div>
      </nav>

      {/* Main Content */}
      <main className="hero-content">
        <Box className="hero-box">
          <div className="hero-icon-wrapper">
            <img
              src="/logo500.png"
              alt="Favicon"
              className="hero-favicon"
              width={200}
              height={200}
            />
          </div>

          <Typography variant="h2" component="h1" className="hero-title">
            Master System Design
          </Typography>

          <Typography variant="h5" className="hero-subtitle">
            A visual, interactive tool for experimenting with system
            architecture. Simulate realistic traffic flows, analyze bottlenecks,
            and prepare for interviews like never before.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="large"
            endIcon={<ArrowForwardIcon />}
            className="cta-button"
            onClick={() => navigate("/app")}
          >
            Start Designing For Free
          </Button>

          <div className="floating-elements">
            <div className="float-block database">
              <PaletteItem
                blockType={BlockTypes.DATABASE}
                onItemClick={() => {}}
              />
            </div>
            <div className="float-block server">
              <PaletteItem
                blockType={BlockTypes.APP_SERVER}
                onItemClick={() => {}}
              />
            </div>
            <div className="float-block cache">
              <PaletteItem
                blockType={BlockTypes.CACHE}
                onItemClick={() => {}}
              />
            </div>
          </div>
        </Box>
      </main>

      <Features />
      <Benefits />
    </div>
  );
};
